import { authRepositoryImplementation } from '@shared/infrastructure/http/repositories/auth/authRepositoryImplementation';

export const authRepository = {
  isAuthenticated: () => {
    return authRepositoryImplementation.isAuthenticated();
  }
};
